// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legalCss_l19hviqa{color:var(--gray60a);font-size:12px;line-height:1.75em;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-footer/dist/es/components/LegalText.css"],"names":[],"mappings":"AAAA,mBAAmB,oBAAoB,CAAC,cAAc,CAAC,kBAAkB,CAAC","sourcesContent":[".legalCss_l19hviqa{color:var(--gray60a);font-size:12px;line-height:1.75em;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
